export class AnalyticsService {
    constructor() {
    }

    static consentModeTypes = [
        'functionality_storage',
        'security_storage',
        'ad_storage',
        'ad_user_data',
        'analytics_storage',
        'personalization_storage',
        'ad_personalization'
    ];

    static callPosthog(name, ...args) {
        if (!window.posthog) {
            return;
        }

        return posthog[name](...args);
    }

    static setPersonProperties(...args) {
        AnalyticsService.callPosthog('setPersonProperties', ...args);
    }

    static capture(...args) {
        AnalyticsService.callPosthog('capture', ...args);
    }

    static onFeatureFlags(...args) {
        AnalyticsService.callPosthog('onFeatureFlags', ...args);
    }

    static getFeatureFlag(...args) {
        return AnalyticsService.callPosthog('getFeatureFlag', ...args);
    }

    static overrideFeatureFlags(...args) {
        if (!window.posthog) {
            return;
        }

        const featureFlags = posthog.featureFlags;

        if (!featureFlags) {
            return;
        }

        featureFlags.override(...args);
    }

    static sendEvent(event, data = {}) {
        const lmsUserData = costorage.get('h_lmsUser');
        let parsedLmsUserData;

        if (lmsUserData) {
            parsedLmsUserData = JSON.parse(lmsUserData);
        }

        if (parsedLmsUserData && parsedLmsUserData['_id']) {
            Object.assign(data, { lms_id: parsedLmsUserData['_id'] });
        }

        const leadsUserData = parsedLmsUserData ?
            {
                "email": parsedLmsUserData.email,
                "phone_number": parsedLmsUserData.phone,
            }
        : null;

        AnalyticsService.capture(event, data);
        dataLayer.push({
            event: event,
            ...data,
            leadsUserData,
        });
    }

    static setConsent(consent) {
        const consentMode = {
            'functionality_storage': consent.necessary ? 'granted' : 'denied',
            'security_storage': consent.necessary ? 'granted' : 'denied',
            'ad_storage': consent.marketing ? 'granted' : 'denied',
            'ad_user_data': consent.marketing ? 'granted' : 'denied',
            'analytics_storage': consent.analytics ? 'granted' : 'denied',
            'personalization_storage': consent.preferences ? 'granted' : 'denied',
            'ad_personalization': consent.preferences ? 'granted' : 'denied',
        };
        gtag('consent', 'update', consentMode);
        costorage.set('h_consentMode', JSON.stringify(consentMode), { expires: 365 * 24 * 60 * 60, path: '/', domain: `.${location.hostname.split('.').reverse()[1]}.${location.hostname.split('.').reverse()[0]}` });
    }

    static getFidCid() {
        let cookie = document.cookie.match('(?:^|;)\\s*_ga=([^;]*)');
        const value = (cookie) ? decodeURIComponent(cookie[1]) : null;
        if (value) {
            cookie = value.match(/(\d+\.\d+)$/);
        }
        const cid = (cookie) ? cookie[1] : null;
        let fid = costorage.get('fid') || null;

        if (fid == null) {
            fid = 'f' + Math.floor((Math.random() * 1000000000) + 1) + '.' + Math.round(Date.now() / 1000)
            costorage.set('fid', fid, {expires: 30, path: '/', domain: craft.env.isInternational ? '.ithillel.com' : '.ithillel.ua' });
        }

        return {
            cid, fid
        };
    }
}